import React from 'react';
import { OwnerDeckNav } from '../components/deck/OwnerDeckNav';
import {
  SlideTitle,
  SlideCaseStudyHighlight,
  SlideProblem,
  SlideSolution,
  SlideValue,
  SlideCaseStudyValue,
  SlideCaseStudyImpact,
  SlideCompetitive,
  SlideDeploymentTimeline,
  SlideDemoVideos,
  SlideClosing,
} from '../components/deck/DeckSlides';

/**
 * Owner/developer deck: same structure as client deck, repurposed for construction
 * owners and developers (e.g. AWS, MS, Meta). Uses forOwner copy throughout.
 * Access at /owner-deck (e.g. https://demo.jobotics.ai/owner-deck).
 */
export default function OwnerDeck() {
  return (
    <div className="min-h-screen bg-white">
      <OwnerDeckNav />
      <main className="deck-export relative">
        <SlideTitle forOwner />
        <SlideCaseStudyHighlight forOwner />
        <SlideProblem forOwner />
        <SlideSolution forOwner />
        <SlideValue forOwner />
        <SlideCaseStudyValue />
        <SlideCaseStudyImpact forOwner />
        <SlideCompetitive forOwner />
        <SlideDeploymentTimeline />
        <SlideDemoVideos />
        <SlideClosing forOwner />
      </main>
    </div>
  );
}
